import { Directive, TemplateRef } from '@angular/core';

// tslint:disable: max-classes-per-file
@Directive({
    selector: '[platformNotificationActionsRightTpl]',
    standalone: false
})
export class PlatformNotificationActionsRightTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
    selector: '[platformNotificationDismissButtonTpl]',
    standalone: false
})
export class PlatformNotificationDismissButtonTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
